<mat-progress-bar mode="indeterminate" *ngIf="in_process"></mat-progress-bar>

<!-- ================= -->
<div fxLayout="row" style="margin-top: 10px">
  <div fxFlex="60" fxFlex.sm="100" fxFlex.xs="100" style="padding: 5px">
    <mat-card>
      <mat-card-header fxLayoutAlign="space-between center">
        <mat-card-title style="margin-left: -16px">¿Qué viste?</mat-card-title>
        <button mat-button color="primary" (click)="fnOpenDialogForm()">
          <mat-icon>add</mat-icon> Agregar variedad
        </button>
      </mat-card-header>

      <mat-card-content>
        <form *ngIf="varietyObservationObject">
          <!-- ================= -->
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="49.5">
              <mat-form-field appearance="outline">
                <mat-label>Cultivo</mat-label>
                <input
                  matInput
                  type="text"
                  name="crop_name"
                  disabled
                  [ngModel]="'Potato'"
                />
              </mat-form-field>
            </div>
            <div fxFlex="44">
              <mat-form-field appearance="outline">
                <mat-label
                  [ngStyle]="{ color: has_error_1 ? '#e91e63' : '#000' }"
                  >Variedad</mat-label
                >
                <input
                  type="text"
                  placeholder="Select one..."
                  aria-label="Variety name"
                  matInput
                  [formControl]="varietyControl"
                  [matAutocomplete]="auto"
                />
                <button
                  mat-button
                  matSuffix
                  aria-label="Arrow"
                  *ngIf="varietyControl.value == null"
                  mat-icon-button
                  class="mat-select-arrow-wrapper"
                >
                  <div class="mat-select-arrow"></div>
                </button>
                <button
                  mat-button
                  *ngIf="varietyControl.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="varietyControl.setValue(null)"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="displayFnVariety"
                  (optionSelected)="selectVariety($event)"
                >
                  <mat-option
                    *ngFor="let option of filteredVarietyOptions | async"
                    [value]="option"
                  >
                    <span>{{ option.variety_name }}</span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div fxFlex="4">
              <button
                #bt
                mat-icon-button
                color="primary"
                (click)="fnOpenDialog()"
              >
                <mat-icon>info_outline</mat-icon>
              </button>
            </div>
          </div>
          <!-- ================= -->
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="40">
              <mat-form-field appearance="outline">
                <mat-label
                  >Estimación de área sembrada ({{
                    varietyObservationObject.estimated_planted_area_unit
                  }})</mat-label
                >
                <input
                  matInput
                  type="number"
                  name="estimated_planted_area"
                  [(ngModel)]="varietyObservationObject.estimated_planted_area"
                />
              </mat-form-field>
            </div>

            <div fxFlex="8.5">
              <mat-form-field appearance="outline">
                <mat-label>Unidad</mat-label>
                <mat-select
                  [(ngModel)]="
                    varietyObservationObject.estimated_planted_area_unit
                  "
                  name="unit_select_name"
                >
                  <mat-option value="AC">AC</mat-option>
                  <mat-option value="HA">HA</mat-option>
                  <mat-option value="M2">M2</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="49.5">
              <mat-form-field appearance="outline">
                <mat-label>Rendimiento en Kg/planta</mat-label>
                <input
                  matInput
                  type="number"
                  name="production"
                  [(ngModel)]="varietyObservationObject.production"
                />
              </mat-form-field>
            </div>
          </div>
          <!-- ================= -->
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            *ngIf="varietyObservationObject.estimated_planted_area > 0"
          >
            <div fxFlex="30">
              <mat-checkbox [(ngModel)]="chm_checked" name="chm_checked_name"
                >Chaqru - Huacuy - Mezcla</mat-checkbox
              >
            </div>

            <div *ngIf="chm_checked" fxFlex="69">
              <mat-form-field appearance="outline">
                <mat-label
                  >Porcentaje de superficie plantada por esta variedad ({{
                    varietyObservationObject.estimated_planted_area_unit
                  }})</mat-label
                >
                <input
                  matInput
                  type="number"
                  name="percentage_area_planted_by_variety"
                  [(ngModel)]="
                    varietyObservationObject.percentage_of_planted_area
                  "
                />
                <span matPrefix style="top: -0.2em !important">% </span>
              </mat-form-field>
            </div>
          </div>
          <!-- ================= -->
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <mat-form-field appearance="outline">
              <mat-label>Comentarios</mat-label>
              <textarea
                matInput
                name="comment"
                [(ngModel)]="varietyObservationObject.comment"
              ></textarea>
            </mat-form-field>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
    <br />

    <mat-card>
      <mat-card-header>
        <mat-card-title style="margin-left: -16px"
          >¿Cuándo lo viste?</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        <label> Fecha de observación: *</label>
        <form *ngIf="varietyObservationObject">
          <div fxFlex="33">
            <mat-form-field color="accent" appearance="outline">
              <mat-label>Fecha de observación</mat-label>
              <input
                matInput
                [matDatepicker]="pickerInit"
                disabled
                [formControl]="date"
                name="observation_date"
                (dateChange)="dateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerInit"
              ></mat-datepicker-toggle>
              <mat-datepicker
                #pickerInit
                color="primary"
                disabled="false"
              ></mat-datepicker>
            </mat-form-field>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
    <br />

    <mat-card>
      <mat-card-header>
        <mat-card-title style="margin-left: -16px">Actividad</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <label> Tipo de actividad: Cómo se ingresan los datos *</label>
        <form *ngIf="varietyObservationObject">
          <mat-radio-group
            class="example-radio-group"
            name="effort_selection"
            [ngStyle]="{ color: has_error_2 ? '#e91e63' : '#000' }"
            [(ngModel)]="varietyObservationObject.effort"
          >
            <mat-radio-button class="example-radio-button" value="SU">
              <span style="white-space: pre-line">
                Encuesta: una encuesta organizada sobre el terreno
              </span>
            </mat-radio-button>
            <mat-radio-button class="example-radio-button" value="HI">
              <span style="white-space: pre-line">
                Histórico: Importación de datos históricos
              </span>
            </mat-radio-button>
            <mat-radio-button class="example-radio-button" value="IN">
              <span style="white-space: pre-line">
                Incidental: Se vio una variedad por casualidad y se ingresó sin
                la organización previa de una encuesta
              </span>
            </mat-radio-button>
            <mat-radio-button class="example-radio-button" value="MO">
              <span style="white-space: pre-line"> Monitorear </span>
            </mat-radio-button>
          </mat-radio-group>
        </form>
      </mat-card-content>
    </mat-card>
    <br />

    <mat-card>
      <mat-card-header>
        <mat-card-title style="margin-left: -16px">Hogar</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <button
          mat-stroked-button
          color="primary"
          (click)="fnGetLastFarmer()"
          style="margin: 0px 20px 0px 0px"
        >
          Usar el último hogar agregado
        </button>

        <button mat-stroked-button color="primary" (click)="fnGetAllFarmer()">
          Busqueda por un hogar cercano
        </button>
      </mat-card-content>

      <mat-card-content *ngIf="search_farmer">
        <mat-form-field appearance="outline">
          <mat-label>Busqueda por un hogar cercano</mat-label>
          <input
            type="text"
            placeholder="Select one..."
            aria-label="Farmer name"
            matInput
            [formControl]="farmerControl"
            [matAutocomplete]="auto_farmer"
          />
          <button
            mat-button
            matSuffix
            aria-label="Arrow"
            *ngIf="farmerControl.value == null"
            mat-icon-button
            class="mat-select-arrow-wrapper"
          >
            <div class="mat-select-arrow"></div>
          </button>
          <button
            mat-button
            *ngIf="farmerControl.value"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="farmerControl.setValue(null)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete
            #auto_farmer="matAutocomplete"
            [displayWith]="displayFnFarmer"
            (optionSelected)="selectFarmer($event)"
          >
            <mat-option
              *ngFor="let option of filteredFarmerOptions | async"
              [value]="option"
            >
              <span>{{ option.farmer_name }}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </mat-card-content>

      <mat-card-content>
        <form *ngIf="varietyObservationObject">
          <!-- ================= -->
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="49.5">
              <mat-form-field appearance="outline">
                <mat-label>Nombre del agricultor</mat-label>
                <input
                  matInput
                  type="text"
                  name="household_growers_name"
                  [(ngModel)]="varietyObservationObject.household.growers_name"
                />
              </mat-form-field>
            </div>
            <div fxFlex="24">
              <mat-form-field appearance="outline">
                <mat-label>Edad del agricultor</mat-label>
                <input
                  name="household_age"
                  type="number"
                  matInput
                  [formControl]="ageFormControl"
                  (ngModelChange)="updateAge($event)"
                  placeholder="Ex. 40"
                />
              </mat-form-field>
            </div>
            <div fxFlex="24.5">
              <mat-form-field appearance="outline">
                <mat-label>Genero</mat-label>
                <mat-select
                  name="varietyItem"
                  [(ngModel)]="varietyObservationObject.household.sex"
                >
                  <mat-option value="M">M</mat-option>
                  <mat-option value="F">F</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <!-- ================= -->
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="49.5">
              <mat-form-field appearance="outline">
                <mat-label
                  >Área del agricultor ({{
                    varietyObservationObject.estimated_planted_area_unit
                  }})</mat-label
                >
                <input
                  matInput
                  type="number"
                  name="household_full_farm_area"
                  [formControl]="areaFormControl"
                  (ngModelChange)="updateArea($event)"
                  placeholder="Ex. 100"
                />
              </mat-form-field>
            </div>

            <div fxFlex="49.5"></div>
          </div>

          <!-- ================= -->
          <div fxLayout="row">
            <mat-slide-toggle
              name="anonymized_control"
              [(ngModel)]="varietyObservationObject.household.anonymized"
              disabled
              >Anonimizar el nombre del agricultor
              {{
                varietyObservationObject.household.anonymized
              }}</mat-slide-toggle
            >
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxFlex="40" fxFlex.sm="100" fxFlex.xs="100" style="padding: 5px">
    <mat-card>
      <mat-card-title> ¿Dónde estabas? </mat-card-title>

      <mat-card-content>
        <form *ngIf="varietyObservationObject">
          <div *ngIf="_location_lat">{{ _location_lat }}</div>
          <div *ngIf="_location_lon">{{ _location_lon }}</div>
          <div *ngIf="_address">{{ _address }}</div>

          <app-template-map-advance
            [(location_object)]="varietyObservationObject"
            [height_value]="'400px'"
            [zoom]="zoom"
          >
          </app-template-map-advance>
        </form>
      </mat-card-content>
    </mat-card>
    <br />
    <app-template-multimedia
      *ngIf="varietyObservationObject"
      [(main_object)]="varietyObservationObject"
      [(main_object_id)]="id"
    ></app-template-multimedia>
  </div>
</div>
<!-- ================= -->
<div fxLayout="row" style="margin-top: 10px">
  <div fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" style="padding: 5px">
    <div class="button-row" style="display: flex; align-items: center">
      <button
        mat-flat-button
        color="primary"
        (click)="save()"
        [disabled]="in_process"
      >
        Guardar observación
      </button>
      <button
        mat-stroked-button
        color="primary"
        routerLink="/tablero/explorer-list-edit"
        [disabled]="in_process"
      >
        Cancelar
      </button>
      <button mat-button [disabled]="in_process">Eliminar</button>
    </div>
  </div>
</div>
